<template>
  <div class="d-flex flex-column justify-center align-center mt-6 mx-8">
    <p class="body2 text-center">{{ $t("guidance.no-content.title") }}</p>
    <p class="body2 text-center mb-0">
      {{ $t("guidance.no-content.contact") }}
    </p>
    <niko-button
      class="mt-10"
      :text="$t('guidance.no-content.button.text')"
      :href="$t('guidance.no-content.button.url')"
      target="_blank"
      type="button"
    />
  </div>
</template>

<script>
import NikoButton from "@/components/UI/NikoButton";

export default {
  name: "no-content",
  components: {
    NikoButton,
  },
};
</script>
